
      import WriteApplication from './write-application.vue'
      import type { App, Plugin } from 'vue'

      export const WriteApplicationPlugin: Plugin = {
        install(app: App) {
          app.component('WriteApplication', WriteApplication)
        },
      }
      export { WriteApplication }
      